import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type AuthUser } from 'wasp/auth';
import { GetAllCollectionsOfUserOutput } from "../admin/dashboards/operations";

type DashboardUserState = "initial" | "connectedShopify" | "importInProgress" | "importedProducts";

const dashboardUserStateOrder: Record<DashboardUserState, number> = {
  "initial": 0,
  "connectedShopify": 1,
  "importInProgress": 2,
  "importedProducts": 3
}


export const compareDashboardUserState = (a: DashboardUserState, b: DashboardUserState) => {
  return dashboardUserStateOrder[a] - dashboardUserStateOrder[b];
}


export interface UserState{
  currentUser: AuthUser | null;
  currentCollection: {
    collection: GetAllCollectionsOfUserOutput | null;
    dashboardUserState: DashboardUserState;
  }
}

const initialState: UserState = {
  currentUser: null,
  currentCollection: {
    collection: null,
    dashboardUserState: "initial"
  }
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<AuthUser>) => {
      state.currentUser = action.payload;
      localStorage.setItem('email', state.currentUser?.email || "");
    },
    setCurrentCollection: (state, action: PayloadAction<GetAllCollectionsOfUserOutput>) => {
      if (!action.payload) {
        state.currentCollection.collection = null;
        state.currentCollection.dashboardUserState = "initial";
        return;
      }

      state.currentCollection.collection = action.payload;
      
      if (action.payload.miqImportMethod === "shopify") {
        if (action.payload.miqHasCompletedShopifyImport) {
          state.currentCollection.dashboardUserState = "importedProducts";
        } else if (action.payload.miqHasStartedShopifyImport) {
          state.currentCollection.dashboardUserState = "importInProgress";
        } else if (action.payload.miqShopifyDomain) {
          state.currentCollection.dashboardUserState = "connectedShopify";
        } else {
          state.currentCollection.dashboardUserState = "initial";
        }
      } else if (action.payload.miqImportMethod === "excel") {
        if (action.payload.miqHasCompletedExcelImport) {
          state.currentCollection.dashboardUserState = "importedProducts";
        } else if (action.payload.miqHasStartedExcelImport) {
          state.currentCollection.dashboardUserState = "importInProgress";
        } else {
          state.currentCollection.dashboardUserState = "initial";
        }
      } else {
        state.currentCollection.dashboardUserState = "initial";
      }
    }
  }
});

export const { setCurrentUser, setCurrentCollection } = userSlice.actions;
export default userSlice.reducer;